<template>
    <div
        class="form-group"
        :class="[
            {
                'form-row': horizontal,
            },
        ]"
    >
        <label
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? class_label : '',
                size == 'sm' ? 'col-form-label-sm' : '',
            ]"
        >
            {{ label }}
        </label>
        <div
            :class="[
                horizontal ? class_input : '',
                size == 'sm' ? 'input-group-sm' : '',
                'codemirror-wrapped'
            ]"
        >
            <codemirror
                ref="cmEditor"
                :value="code"
                :options="cmOptions"
                @ready="onCmReady"
                @focus="onCmFocus"
                @input="onCmCodeChange"
            />
        </div>
    </div>
</template>

<script>
// import dedent from "dedent";
import { codemirror } from "vue-codemirror";
// import 'codemirror/theme/base16-dark.css'
// language
import "codemirror/mode/css/css.js";
import "codemirror/mode/xml/xml.js";
import "codemirror/mode/htmlmixed/htmlmixed.js";

// merge css
// import "codemirror/addon/merge/merge.css";

// merge js
// import "codemirror/addon/merge/merge.js";

// google DiffMatchPatch
// import DiffMatchPatch from "diff-match-patch";
import "codemirror/lib/codemirror.css";
// window.diff_match_patch = DiffMatchPatch;
// window.DIFF_DELETE = -1;
// window.DIFF_INSERT = 1;
// window.DIFF_EQUAL = 0;
export default {
    name: "LCodeEditor",
    components: {
        codemirror,
    },
    data() {
        return {
            code: "",
            cmOptions: {
                tabSize: 4,
                connect: "align",
                mode: "htmlmixed",
                htmlMode: true,
                autoCloseBrackets: true,
                autoCloseTags: true,
                collapseIdentical: false,
                highlightDifferencexmls: true,
                // theme: "base16-dark",
                lineNumbers: true,
                line: true,
                // more CodeMirror options...
            },
            class_label: "col-sm-2",
            class_input: "col-sm-10",
        };
    },
    props: {
        value: {
            default: null,
        },
        options: {
            default: null,
        },
        label: {
            default: null,
        },
        horizontal: {
            default: null,
        },
        size: {
            default: "md",
        },
        loading: {
            default: false,
        },
    },
    watch: {
        value(newValue) {
            this.code = newValue;
        },
        loading(newValue) {
            if (newValue === false) this.$refs.cmEditor.codemirror.refresh();
        },
    },
    computed: {
        codemirror() {
            return this.$refs.cmEditor.codemirror;
        },
    },
    methods: {
        onCmReady(cm) {
            this.$emit("ready", cm);
        },
        onCmFocus(cm) {},
        onCmCodeChange(newCode) {
            this.code = newCode;
            this.$emit("update:value", newCode);
            this.$emit("change", newCode);
        },
    },
    mounted() {
        this.code = this.value;
        if (this.options) this.cmOptions = this.options;
        if (this.loading === false) this.$refs.cmEditor.codemirror.refresh();
        this.codemirror.setSize("100%", "50vh");
    },
};
</script>

<style>
.codemirror-wrapped {
    min-height: 70vh;
}
</style>